import type {Bank} from '@rocket-ui/lk-api';

export type SelectedBank = Pick<Bank, 'id' | 'bik' | 'shortName' | 'iconUrl'>;

export function bankFromApi(bank: Bank): SelectedBank {
	return {
		id: bank.id,
		bik: bank.bik ?? null,
		shortName: bank.shortName ?? null,
		iconUrl: bank.iconUrl ?? null,
	};
}
